const CLIENT_ID_KEY = "ptp.join.clientId";

/**
 * A localStorage uuid used as the X-Client-Id fallback.
 *
 * The signed cookie is the primary identity, but iOS Safari in private or lockdown
 * mode can refuse cookies entirely; without this fallback one visitor there could
 * spawn unlimited particles.
 */
export function clientId(): string {
  try {
    const existing = localStorage.getItem(CLIENT_ID_KEY);
    if (existing) return existing;
    const created = crypto.randomUUID();
    localStorage.setItem(CLIENT_ID_KEY, created);
    return created;
  } catch {
    return crypto.randomUUID();
  }
}
